var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconIncidencia(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 63.6 58.2",
    style: {
      enableBackground: "new 0 0 63.6 58.2"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M31.8,0c-2.4,0-4.8,1.2-6.1,3.6l-25,45.5c-2.2,4,0.8,9.1,5.4,9.1h51.3c4.6,0,7.6-5.1,5.4-9.1L37.9,3.6 C36.6,1.2,34.2,0,31.8,0L31.8,0z M31.8,3.7c1.1,0,2.2,0.6,2.8,1.7l24.9,45.5c0.9,1.7-0.2,3.5-2.1,3.5H6.1c-1.9,0-3-1.8-2.1-3.5 L28.9,5.4C29.6,4.3,30.7,3.7,31.8,3.7L31.8,3.7z M31.8,20.6L31.8,20.6c-1.1,0-1.9,0.8-1.9,1.9v15.9c0,1,0.9,1.9,1.9,1.9 c1,0,1.9-0.8,1.9-1.9V22.5C33.7,21.5,32.8,20.6,31.8,20.6L31.8,20.6z M31.8,42.9L31.8,42.9c-1.1,0-1.9,0.9-1.9,1.9V46 c0,1,0.9,1.9,1.9,1.9c1,0,1.9-0.9,1.9-1.9v-1.2C33.7,43.7,32.8,42.9,31.8,42.9L31.8,42.9z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconIncidencia);
export default __webpack_public_path__ + "static/media/icon_incidencia.90ae07f424bf7fe688a13f8546534cc1.svg";
export { ForwardRef as ReactComponent };